// src/components/BidCard.jsx
import React, { useState } from 'react';
import './BidCard.css';
import foodImage from '../image/food-img.png'; // replace with your actual image path
import { is, tr } from 'date-fns/locale';
import { API_BASE_URL } from '../../utils';

const BidCard = ({ data }) => {

    const url = `${API_BASE_URL}/master/assets/uploads/`;

    return (
        <>
            <div className="bid-card">
                <img src={url + data.clubLogo} alt="Food" className="bid-card-image" />
                <div className="bid-card-info">
                    <div className="bid-card-header">
                        <div className='bid-card-text-sec'>
                            <h3 className="bid-title">{data.clubName}</h3>
                            <p className="bid-subtitle">{data.title}</p>
                            <a href="#" className="view-link">View Details</a>
                        </div>
                        <div className="bid-amount">
                            <span>Bid Amount</span>
                            <strong className="bid-amount">Rs {data.price}/-</strong>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BidCard;
